// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + {"6823":"__federation_expose_mount","7367":"vendor-blueprint"}[chunkId] + "." + {"6823":"c64684dddf1d0cbbd1f7","7367":"6466cd562ffd99dd92d6"}[chunkId] + ".css";
};